import { Typography } from '@material-ui/core'
import { LoginForm } from '../../components/authentication/login'
// components
import Page from '../../components/Page'
// layouts
import AuthLayout from '../../layouts/AuthLayout'
import GenesusName from '../../components/GenesusName'

// ----------------------------------------------------------------------

export default function Login() {
  return (
    <Page title="Login | Genesus">
      <AuthLayout>
        <Typography variant="h4" component="h1">
          Sign in to <GenesusName />
        </Typography>
        <Typography variant="body2" sx={{ mt: 1, mb: 4, color: 'text.secondary' }}>
          Use the email and password of your <GenesusName /> account.
        </Typography>

        <LoginForm />
      </AuthLayout>
    </Page>
  )
}
